export const reportWarnings = Object.freeze({
  failedPaymentMessage: 'Do not release: Past due invoices!',
  containerNumberIsoWarning: 'Container number is not ISO 6346 compliant',
});